import { ConditionOperatorEnumType } from '@reach/shared-types/conditions';
import { useState } from 'react';
import { RelativeDateBuilder } from '../RelativeDateBuilder';
import styles from '../SegmentVisualBuilder.module.css';
import { AbsoluteDateInput } from './AbsoluteDateInput';
import { DateValueModeToggle } from './DateValueModeToggle';
import { ResolvedDatePreview } from './ResolvedDatePreview';
import { getDateValueMode, isRelativeDate } from './date-value-utils';
import type { DateOperatorInputProps, DateValueMode } from './types';

export function EqualsDateInput({ operator, value, onChange, disabled }: DateOperatorInputProps) {
  const isExactDate = operator === ConditionOperatorEnumType.EQUALS_MONTH_DAY_YEAR;
  const [selectedDateValueMode, setSelectedDateValueMode] = useState<DateValueMode | null>(null);
  const derivedDateValueMode = getDateValueMode(value);
  const defaultDateValueMode: DateValueMode = isExactDate ? 'absolute' : 'relative';
  const dateValueMode = derivedDateValueMode ?? selectedDateValueMode ?? defaultDateValueMode;

  const handleDateValueModeChange = (nextDateValueMode: DateValueMode) => {
    setSelectedDateValueMode(nextDateValueMode);
    onChange([]);
  };

  if (!isExactDate) {
    const relative = value != null && isRelativeDate(value) ? value : null;
    return (
      <div className={styles.dateVariantWrapper}>
        <RelativeDateBuilder value={relative} onChange={rel => onChange([rel])} disabled={disabled} />
        <ResolvedDatePreview operator={operator} value={value} />
      </div>
    );
  }

  return (
    <div className={styles.dateVariantWrapper}>
      <DateValueModeToggle
        dateValueMode={dateValueMode}
        onChange={handleDateValueModeChange}
        disabled={disabled}
      />
      {dateValueMode === 'absolute' ? (
        <AbsoluteDateInput value={value} onChange={onChange} disabled={disabled} />
      ) : (
        <RelativeDateBuilder
          value={value != null && isRelativeDate(value) ? value : null}
          onChange={rel => onChange([rel])}
          disabled={disabled}
        />
      )}
      <ResolvedDatePreview operator={operator} value={value} />
    </div>
  );
}
